"use client";
import React from "react";
import { ToolProps } from "@/types";
import { usePathname } from "next/navigation";

const UpcomingToolCard = ({ tool }: ToolProps) => {
  const path = usePathname();

  return (
    <>
      <div
        className={` ${
          path == "/tools"
            ? "h-[313px] max-w-[445px]"
            : "h-[228px] max-w-[305px]"
        } css-selector flex size-full items-center justify-center rounded-[30px] border`}
      >
        <div className="flex flex-col items-center justify-center">
          <div className="cursor-default rounded-full bg-black/80 px-3 py-1 text-xs font-medium text-white">
            ✨coming soon!
          </div>
          <h1
            className={` ${
              path == "/tools"
                ? "text-4xl leading-10"
                : "text-[24px] leading-[28px]"
            } pt-2 text-center text-4xl font-bold text-white drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]`}
          >
            {tool.title}
          </h1>
        </div>
      </div>
    </>
  );
};

export default UpcomingToolCard;
